import React from 'react';
import { Subtract } from 'utility-types';

import { ISanitizer, sanitize } from '../../commonInfra/utils/Sanitize';
import { IPlace } from '../../ts/models/IPlace';

export interface InjectedFlowSpaceServiceInjectorProps {
  readonly place: IPlace;
  readonly sanitizer: ISanitizer;
}

export interface FlowSpaceServiceInjectorProps {
  readonly flowId: string;
}

export function withFlowSpaceServiceInjector<P extends InjectedFlowSpaceServiceInjectorProps>(
  Component: React.ComponentType<P>
) {
  return function FlowSpaceServiceInjector(
    props: Subtract<P, InjectedFlowSpaceServiceInjectorProps> & FlowSpaceServiceInjectorProps
  ) {

    return <Component
      {...props as unknown as P}
      sanitizer={sanitize}
    />;
  };
}
